import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import { User } from 'types/api/users.type';
import { Row } from 'types';

import * as S from './Categories.styles';

export const useColumns = (onClick: (arg: Row, user?: User) => void, user?: User) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Users',
        columns: [
          {
            Header: 'Season',
            accessor: 'season',
          },
          {
            Header: 'Catalog',
            accessor: 'catalog',
          },
          {
            Header: '',
            accessor: 'id',
            Cell: ({ row }) => (
              <S.ButtonRemove
                iconLeft="FiX"
                motive="primaryBlack"
                onClick={() => onClick(row, user)}
              />
            ),
          },
        ],
      },
    ],
    [user]
  );
